import type {ReactAction} from '@netx/core/bootstrap';
import {faLink} from '@fortawesome/pro-solid-svg-icons';
import {canCreateShareLinkFromCategory} from '../enablers';
import {CategoryActionLabel} from '../locales';
import {type ICategory} from '../schema';
import {CATEGORY_EVENT} from './constants';

export const categoryActionShareLinkIcon = faLink;

/**
 * Category share link
 * @param params
 * @returns Action
 */
export const categoryActionShareLink = (
	category?: ICategory,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'category-share-link',
	cb: () => dispatcher.trigger(CATEGORY_EVENT.SHARE_LINK, category),
	enableTest: () => canCreateShareLinkFromCategory(category),
	icon: categoryActionShareLinkIcon,
	get label() {
		return CategoryActionLabel.SHARE_LINK;
	},
	...params,
});

export default categoryActionShareLink;
